import { FC } from "react";

import { useAppDispatch } from "../../../../hook/useAppDispatch";
import { useAppSelector } from "../../../../hook/useAppSelector";

import { setIsThumbnailView } from "../../../../store/slice/config/config";

import gridIcon from "../../../../assets/img/svg/health-monitor/grid-icon.svg";
import listIcon from "../../../../assets/img/svg/health-monitor/list-icon.svg";

import { useTranslation } from "react-i18next";

const ThumbnailView: FC = () => {
  const isThumbnailView = useAppSelector(
    (state) => state.configSlice.isThumbnailView
  );
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  return (
    <div
      className="thumbnail_view"
      onClick={() => {
        dispatch(setIsThumbnailView());
      }}
    >
      <img
        src={isThumbnailView ? listIcon : gridIcon}
        alt="content_view_img"
      ></img>
      <span>
        {isThumbnailView
          ? t("healthMonitor.footer.contentView.listView")
          : t("healthMonitor.footer.contentView.gridView")}
      </span>
    </div>
  );
};

export default ThumbnailView;
